"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Legend = _interopRequireDefault(require("../Legend"));

var _Button = _interopRequireDefault(require("../Button"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _Slide = _interopRequireDefault(require("./component/Slide"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Slider = /*#__PURE__*/function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Slider).apply(this, arguments));
  }

  _createClass(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          transitionSlide = _this$props.transitionSlide,
          slides = _this$props.slides,
          containerWidth = _this$props.containerWidth,
          slideArray = _this$props.slideArray,
          shouldAnimate = _this$props.shouldAnimate,
          index = _this$props.index,
          withBorder = _this$props.withBorder,
          handleLegend = _this$props.handleLegend,
          handlePrevSlide = _this$props.handlePrevSlide,
          handleNextSlide = _this$props.handleNextSlide,
          timeAnimation = _this$props.timeAnimation,
          arrow = _this$props.arrow,
          legend = _this$props.legend,
          classes = _this$props.classes;
      var animationTime = timeAnimation === 35 ? 0.035 : 0.4;
      return _react["default"].createElement(_react.Fragment, null, arrow && arrow.position === _constants.INSIDE && _react["default"].createElement(_Button["default"], {
        ArrowCustom: arrow.arrowCustomLeft,
        callback: arrow.callbackLeft,
        left: true,
        onPress: handlePrevSlide,
        className: _stylesModule["default"].arrowLeft,
        classes: classes
      }), _react["default"].createElement("div", {
        style: {
          transform: "translate3d(".concat(transitionSlide, "px, 0px, 0px)"),
          width: "".concat(containerWidth * slideArray.length, "px"),
          transition: "".concat(shouldAnimate ? "transform ".concat(animationTime, "s linear 0s") : 'none')
        },
        className: "".concat(_stylesModule["default"].slideContainer),
        draggable: "false"
      }, slideArray.map(function (element, _index) {
        return _react["default"].createElement(_Slide["default"], {
          keyName: "slide-key-".concat(element.id),
          position: _index - 1,
          currentSlide: index - 1,
          widthContainer: containerWidth,
          imgSrc: element.imgSrc,
          border: withBorder,
          shouldAnimate: shouldAnimate,
          animationTime: animationTime,
          onClick: element.onClick
        });
      })), legend && legend.position === _constants.INSIDE && _react["default"].createElement("div", {
        className: _stylesModule["default"].legendContainer
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].legend
      }, slides.map(function (_, item) {
        return _react["default"].createElement(_Legend["default"], {
          keyName: "legend-key-".concat(item),
          LegendCustom: legend.legendCustom,
          index: item,
          currentSlide: index === slideArray.length - 1 ? 0 : index === 0 ? 1 : index - 1,
          onClick: handleLegend,
          classes: classes
        });
      }))), arrow && arrow.position === _constants.INSIDE && _react["default"].createElement(_Button["default"], {
        ArrowCustom: arrow.arrowCustomRight,
        callback: arrow.callbackRight,
        onPress: handleNextSlide,
        className: _stylesModule["default"].arrowRight,
        classes: classes
      }));
    }
  }]);

  return Slider;
}(_react.PureComponent);

Slider.propTypes = {
  slideArray: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    imgSrc: _propTypes.string,
    id: _propTypes.number
  })),
  slides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    imgSrc: _propTypes.string
  })),
  arrow: (0, _propTypes.shape)({
    position: _propTypes.string,
    arrowCustomLeft: _propTypes.node,
    arrowCustomRight: _propTypes.node,
    callbackLeft: _propTypes.func,
    callbackRight: _propTypes.func
  }),
  legend: (0, _propTypes.shape)({
    position: _propTypes.string,
    legendCustom: _propTypes.node
  }),
  transitionSlide: _propTypes.number,
  containerWidth: _propTypes.number,
  shouldAnimate: _propTypes.bool,
  index: _propTypes.number,
  withBorder: _propTypes.number,
  handleLegend: _propTypes.func,
  handlePrevSlide: _propTypes.func,
  handleNextSlide: _propTypes.func,
  timeAnimation: _propTypes.number,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};
var _default = Slider;
exports["default"] = _default;